export const defaultQuantity = "" as unknown as number;
